module.exports = __webpack_public_path__ + "static/media/medium-white.6148c8a3.svg";